import type { FormConfig } from '@tencent/wb-ext-form';
import { FormItemName, FormItemLabelName, FormItemType } from '@framework/workbench/drawer/constants';
import i18n from '@i18next/i18n';
import { AutoFitType, TextDirectionType } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/text-style-type';
import { CSSProperties } from 'react';

const selectOptions = [
    { key: AutoFitType.NO_AUTO_FIT, content: i18n.t('不自动调整') },
    { key: AutoFitType.FONT_AUTO_FIT, content: i18n.t('溢出时缩排文字') },
    { key: AutoFitType.SHAPE_AUTO_FIT, content: i18n.t('根据文字调整形状大小') },
];
export const NUMBER_INPUT_OPTION = {
    STEP: 0.1,
    // 最大长度对齐本地客户端
    MAX: 55.88,
    MIN: 0,
    TO_FIXED: 2,
    ALLOW_DECIMAL: true,
};

const SpinOptions = {
    step: NUMBER_INPUT_OPTION.STEP,
    allowDecimal: NUMBER_INPUT_OPTION.ALLOW_DECIMAL,
    toFixed: NUMBER_INPUT_OPTION.TO_FIXED,
    max: NUMBER_INPUT_OPTION.MAX,
    min: NUMBER_INPUT_OPTION.MIN,
};

const SpinStyle = {
    fontSize: '12px',
    minWidth: 56,
};

export const fontStyle: CSSProperties = {
    color: 'rgba(0, 0, 0, 0.4)',
    fontSize: 12,
    fontWeight: 500,
    marginBottom: -2,
};

export const FORM_CONFIGS: FormConfig[] = [
    {
        name: FormItemName.FONT_ADJUST_TEXT,
        type: FormItemType.TEXT,
        value: i18n.t('文本自动调整'),
        style: fontStyle,
    },
    {
        type: FormItemType.SELECT,
        name: FormItemName.FONT_ADJUST,
        options: {
            selectOptions,
        },
    },
    {
        name: FormItemName.TEXT_DIRECTION_LABEL,
        type: FormItemType.TEXT,
        value: i18n.t('文字方向'),
        style: fontStyle,
    },
    {
        type: FormItemType.SELECT,
        name: FormItemName.TEXT_DIRECTION,
        options: {
            selectOptions: [
                { key: TextDirectionType.HORIZONTAL, content: i18n.t('横排') as string },
                { key: TextDirectionType.VERTICAL, content: i18n.t('竖排') as string },
                { key: TextDirectionType.ROTATE_90, content: i18n.t('将所有文字旋转 90°') as string },
                { key: TextDirectionType.ROTATE_270, content: i18n.t('将所有文字旋转 270°') as string },
                { key: TextDirectionType.WORD_ART_VERTICAL_GENERAL, content: i18n.t('堆积') as string },
            ],
        },
    },
    {
        name: FormItemName.ORDER_OF_LINE_LABEL,
        type: FormItemType.TEXT,
        value: i18n.t('行顺序'),
        style: fontStyle,
    },
    {
        type: FormItemType.SELECT,
        name: FormItemName.ORDER_OF_LINE,
        options: {
            selectOptions: [
                { key: TextDirectionType.WORD_ART_VERTICAL_RTL, content: i18n.t('从右向左') as string },
                { key: TextDirectionType.WORD_ART_VERTICAL_LTR, content: i18n.t('从左向右') as string },
            ],
        },
    },
    {
        name: FormItemName.FONT_PADDING_TEXT,
        type: FormItemType.TEXT,
        value: i18n.t('文字边距'),
        style: fontStyle,
    },
    {
        name: FormItemName.FONT_PADDING_UNIT,
        type: FormItemType.TEXT,
        value: i18n.t('单位：厘米'),
        style: { ...fontStyle, display: 'flex', justifyContent: 'flex-end' },
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.FONT_PADDING_LEFT,
        label: FormItemLabelName.LEFT,
        options: SpinOptions,
        style: SpinStyle,
        defaultValue: 0,
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.FONT_PADDING_RIGHT,
        label: FormItemLabelName.RIGHT,
        options: SpinOptions,
        style: SpinStyle,
        defaultValue: 0,
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.FONT_PADDING_TOP,
        label: FormItemLabelName.TOP,
        options: SpinOptions,
        style: SpinStyle,
        defaultValue: 0,
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.FONT_PADDING_BOTTOM,
        label: FormItemLabelName.BOTTOM,
        options: SpinOptions,
        style: SpinStyle,
        defaultValue: 0,
    },
    {
        name: FormItemName.FONT_AUTO_BREAK,
        type: FormItemType.CHECKBOX,
        label: FormItemLabelName.FONT_AUTO_BREAK,
        defaultValue: true,
        options: {
            fillType: 'tick',
        },
    },
];
